<template>
  <client-only>
    <VueSlickCarousel
      ref="carousel"
      v-bind="sliderOptions"
    >
      <div
        v-for="(image, index) in images"
        :key="index"
      >
        <OImage
          :desktop="image.desktop"
          :mobile="image.mobile"
          :src="image.src"
          :alt="image.alt || $t('Accessibilty.AltTags.ProductImage')"
        />
      </div>

      <template #prevArrow="">
        <button
          :aria-label="$t('Accessibilty.AriaLabels.PreviousSlide')"
          class="square-slider-arrow square-slider-arrow-prev"
        >
          <OSvg class="w-5 h-5 fill-current" svg="new-chevron-left" />
        </button>
      </template>

      <template #nextArrow="">
        <button
          :aria-label="$t('Accessibilty.AriaLabels.NextSlide')"
          class="square-slider-arrow square-slider-arrow-next"
        >
          <OSvg class="w-5 h-5 fill-current" svg="new-chevron-right" />
        </button>
      </template>

      <template #customPaging="">
        <div>
          <button
            class="custom-dot appearance-none focus:outline-none"
          />
        </div>
      </template>
    </VueSlickCarousel>
  </client-only>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
const OSvg = () => import('@/components/OSvg')
const OImage = () => import('@/components/OImage')

export default {
  name: 'SimpleSlider',
  components: {
    VueSlickCarousel,
    OSvg,
    OImage
  },
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    slidesToShow: {
      type: Number,
      default: 1
    },
    slidesToScroll: {
      type: Number,
      default: 1
    },
    infinite: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    autoplaySpeed: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    sliderOptions () {
      return {
        arrows: true,
        dots: true,
        infinite: this.infinite,
        slidesToShow: this.slidesToShow,
        slidesToScroll: this.slidesToScroll,
        autoplay: this.autoplay,
        autoplaySpeed: this.autoplaySpeed,
        speed: 500,
        fade: false,
        cssEase: 'ease'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
>>> .slick-dots {
  @apply flex gap-1 justify-center pt-5 !important;

  .custom-dot {
    @apply w-3 h-3 rounded-full bg-gray-200;
  }
}

.slick-active {
  .custom-dot {
    @apply bg-gray-500;
  }
}

>>> .square-slider-arrow {
  @apply bg-white shadow-xl rounded-full w-10 h-10 flex items-center justify-center transition-shadow;
}

>>> .square-slider-arrow-prev {
  @apply absolute z-10;
  left: -2rem;
  top: 50%;
  transform: translateY(-80%);
}

>>> .square-slider-arrow-next {
  @apply absolute z-10;
  right: -2rem;
  top: 50%;
  transform: translateY(-80%);
}
</style>
